var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { _PdfDecodeStream } from '../decode-stream';
var _PdfRunLengthStream = /** @class */ (function (_super) {
    __extends(_PdfRunLengthStream, _super);
    function _PdfRunLengthStream(str, maybeLength) {
        var _this = _super.call(this, maybeLength) || this;
        _this.stream = str;
        _this.dict = str.dict;
        return _this;
    }
    _PdfRunLengthStream.prototype.readBlock = function () {
        var repeatHeader = this.stream.getBytes(2); // eslint-disable-line
        if (!repeatHeader || repeatHeader.length < 2 || repeatHeader[0] === 128) {
            this.eof = true;
            return;
        }
        var buffer; // eslint-disable-line
        var bufferLength = this.bufferLength;
        var n = repeatHeader[0];
        if (n < 128) {
            buffer = this.ensureBuffer(bufferLength + n + 1);
            buffer[bufferLength++] = repeatHeader[1];
            if (n > 0) {
                var source = this.stream.getBytes(n); // eslint-disable-line
                buffer.set(source, bufferLength);
                bufferLength += n;
            }
        }
        else {
            n = 257 - n;
            buffer = this.ensureBuffer(bufferLength + n + 1);
            buffer.fill(repeatHeader[1], bufferLength, bufferLength + n);
            bufferLength += n;
        }
        this.bufferLength = bufferLength;
    };
    return _PdfRunLengthStream;
}(_PdfDecodeStream));
export { _PdfRunLengthStream };
